import { render } from "./CalculatorResultSection.vue?vue&type=template&id=efda4cd8&scoped=true&ts=true&lang=pug"
import script from "./CalculatorResultSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalculatorResultSection.vue?vue&type=script&lang=ts&setup=true"

import "./CalculatorResultSection.vue?vue&type=style&index=0&id=efda4cd8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efda4cd8"]])

export default __exports__